import { Button, Paragraph, Separator, useInfoSheet } from '@fs/zion-ui'
import React from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { GedcomInfoSheet } from '@fs/zion-controlled-edit-trees'
import { useGroupsContext } from '@fs/zion-tree-groups'
import { useGedcomData } from '../../providers/GedcomDataProviderSmart'

export default function UploadReport(): JSX.Element | null {
  const [t] = useTranslation()
  const { gedcomData, refetchGedcomData } = useGedcomData()
  const { treeDetails } = useGroupsContext()
  const gedcomErrorsInfoSheet = useInfoSheet()
  const hasDifferences =
    treeDetails && !treeDetails.hidden && gedcomData && gedcomData.errorCount > 0 && !gedcomData.errorReviewDone

  if (!hasDifferences) return null

  return (
    <>
      <Paragraph size="sm">
        <Trans i18nKey="group-management.upload-report.heading" values={{ number: gedcomData.errorCount }} />
      </Paragraph>

      <Separator size="nano" />

      <Button data-testid="review-errors" onClick={gedcomErrorsInfoSheet.handleClick}>
        {t('group-management.review.action')}
      </Button>

      <GedcomInfoSheet
        fileName={gedcomData.fileName}
        infoSheet={gedcomErrorsInfoSheet}
        onDoneReviewing={refetchGedcomData}
      />
    </>
  )
}
